import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./animations.css";
import "./utils.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { FirebaseProvider } from "./providers/FirestoreProvider";
import { initalizeFirebase } from "./initializeFirebase";
initalizeFirebase();

ReactDOM.render(
  <React.StrictMode>
    <FirebaseProvider>
      <App />
    </FirebaseProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log("Service worker registered")
  },
  onUpdate: () => {
    console.log("Service worker updated")
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
